
import { Component, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ItemsService } from '../../../../services/items.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ElementRef } from '@angular/core';
import { ViewChild } from '@angular/core';
import Swal from 'sweetalert2';

import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { UserService } from '../../../../services/user';
import { PetServices } from '../../../../services/petservices';


@Component({
  selector: 'app-addservice',
  templateUrl: './addservice.component.html',
  styleUrl: './addservice.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AddserviceComponent {

  name_en!: string;
  name_ar!: string;
  warehouses!: any;
  warehouseId!: any;
  contentReady: boolean = false;
  weight!: string;
  type!: string;
  quantity!: string;
  expiration_data!: Date | string;
  price!: string;
  sku!: string;
  isActive = true;
  pricea!: string;
  pricec!: string;
  priceb!: string;

  category_id!: number;
  affiliationprice!: string;
  itemId!: string;
  hasToken: boolean = false;
  data!: FormGroup;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  itemData!: any;
  isUpdatePage = false;
  locationById: any;
  text: any;
  isMobile: boolean = false;
  isAr: boolean = false;
  submitted: boolean = false;
  isAdmin!: boolean;
  accountType!: string;

  barcode!: string;
  pet!: any;
  pet_type!: any;
  brands: any[] = [];
  brand_id: number | null = null;
  isClone!: boolean;
  product_info_en!: string;
  product_info_ar!: string;
  selectedFile!: File | null;
  selectedFilePreview: any;

  tags: string = '';
  tagsArray: string[] = [];
  constructor(
    private router: Router,
    private _ItemsService: ItemsService,
    private fb: FormBuilder,
    private _userService: UserService,
    private deviceService: DeviceDetectorService,
    private route: ActivatedRoute,
    private _petServices: PetServices
  ) { }

  token = localStorage.getItem('token');
  ngOnInit() {
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem("language") == "ar";
    this.warehouseId = localStorage.getItem("posId");
    this.initiate();
    ;

    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1" || this.accountType == "10";



      },
      error: (error) => console.error(error),
    });
    this.route.queryParams.subscribe(params => {

      if (!this.isEmpty(params)) {
        if (params["isClone"])
          this.isClone = true;
        else
          this.isUpdatePage = true;
      }
      this.itemId = params["id"];
      this.name_en = params["name_en"];
      this.name_ar = params["name_ar"];
      this.weight = params["weight"];
      this.price = params["price"];

      this.product_info_en = params["product_info_en"];
      this.product_info_ar = params["product_info_ar"];

      this.pricea = params["pricea"];




      this.pet = params["pet"];
      this.pet_type = params["pet_type"];
    });

  }



  isEmpty(obj: any): boolean {
    return !obj || Object.keys(obj).length === 0;
  }



  initiate() {
    this.data = this.fb.group({
      name_ar: ['', [Validators.required, Validators.minLength(2)]],
      name_en: ['', [Validators.required, Validators.minLength(2)]],

      product_info_en: [''],
      product_info_ar: [''],

      price: ['', [Validators.required, Validators.pattern(/^\d{1,6}(\.\d{1,2})?$/)]],


      pet: [''],
      pet_type: [''],

      pricea: ['', [Validators.required, Validators.pattern(/^\d{1,6}(\.\d{1,2})?$/)]],

      affiliationprice: [''],

    });
  }

  shouldShowError(controlName: string): boolean {
    const control = this.data?.get(controlName);
    return !!control && control.invalid && (control.touched || this.submitted);
  }

  getErrorMessage(controlName: string, label: string): string {
    const control = this.data?.get(controlName);

    if (!control || !control.errors) {
      return '';
    }

    if (control.errors['required']) {
      return this.isAr ? `${label} مطلوب` : `${label} is required`;
    }

    if (control.errors['minlength']) {
      const requiredLength = control.errors['minlength'].requiredLength;
      return this.isAr
        ? `${label} لازم يكون ${requiredLength} حروف على الاقل`
        : `${label} must be at least ${requiredLength} characters`;
    }

    if (control.errors['pattern']) {
      if (['price', 'pricea'].includes(controlName)) {
        return this.isAr
          ? `${label} لازم يكون رقم من 1 الى 6 ارقام`
          : `${label} must be a number from 1 to 6 digits`;
      }
    }

    return this.isAr ? `${label} غير صحيح` : `${label} is invalid`;
  }

  getMissingRequiredCount(): number {
    if (!this.data) {
      return 0;
    }

    return Object.keys(this.data.controls).filter((controlName) => {
      const control = this.data.get(controlName);
      return control?.hasError('required');
    }).length;
  }

  private validateBeforeSubmit(): boolean {
    this.submitted = true;

    if (this.data.invalid) {
      this.data.markAllAsTouched();
      Swal.fire({
        icon: 'warning',
        title: this.isAr ? 'تأكد من بيانات الخدمة' : 'Please check service data',
        text: this.isAr
          ? 'راجع الحقول المطلوبة قبل الحفظ'
          : 'Review the required fields before saving',
        confirmButtonText: this.isAr ? 'تمام' : 'ok',
      });
      return false;
    }

    return true;
  }
  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      const maxSize = 2 * 1024 * 1024; // 2MB

      if (file.size > maxSize) {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? 'حجم الصورة كبير' : 'Image too large',
          text: this.isAr
            ? 'حجم الصورة يجب ألا يزيد عن 2 ميجابايت'
            : 'Image size must not exceed 2 MB',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });

        this.selectedFile = null;
        this.selectedFilePreview = null;
        event.target.value = '';
        return;
      }

      this.selectedFile = file;

      const reader = new FileReader();
      reader.onload = e => {
        this.selectedFilePreview = e.target?.result;
      };
      reader.readAsDataURL(file);
    }
  }


  dataForm: any;
  appendPostDtata() {
    this.dataForm = new FormData();
    this.dataForm.append('name_en', this.name_en);
    this.dataForm.append('name_ar', this.name_ar);

    this.dataForm.append('product_info_en', this.product_info_en);
    this.dataForm.append('product_info_ar', this.product_info_ar);


    if (this.selectedFile) {
      this.dataForm.append('image', this.selectedFile);
    }

    this.dataForm.append('warehouse_id', this.warehouseId);
    this.dataForm.append('price', this.price);

    this.dataForm.append('pricea', this.pricea);

    this.dataForm.append('pet', this.pet);
    this.dataForm.append('pet_type', this.pet_type);
  }

  onSubmit() {
    if (!this.validateBeforeSubmit()) {
      return;
    }

    this.contentReady = true;
    this.appendPostDtata();
    if (this.isUpdatePage)
      this.onUpdate()
    else
      this.onAdd()
  }
  onAdd() {
    this._petServices.create(this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم اضافة خدمة" : 'service created',
          showConfirmButton: false,
          timer: 1500,
        });
        this.contentReady = false;
        this.isMobile? this.router.navigateByUrl('/AllServices.mobile') :
        this.router.navigateByUrl('/AllServices');
      },
      error: (err) => {
        this.contentReady = false;

        const backendMessage =
          err?.error?.errors?.image?.[0] ||
          err?.error?.message ||
          (this.isAr ? 'فشل حفظ الخدمة' : 'service not created');

        Swal.fire({
          icon: 'error',
          title: this.isAr ? 'فشل حفظ الخدمة' : 'service not created',
          text: this.isAr
            ? this.translateBackendError(backendMessage)
            : backendMessage,
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });
      },
    });
  }
  onUpdate() {
    this._petServices.update(parseInt(this.itemId), this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم تعديل خدمة" : 'service changed',
          showConfirmButton: false,
          timer: 1500,
        });
        this.contentReady = false;
        this.isMobile? this.router.navigateByUrl('/AllServices.mobile') :
        this.router.navigateByUrl('/AllServices');
      },
      error: (err) => {
        this.contentReady = false;

        const backendMessage =
          err?.error?.errors?.image?.[0] ||
          err?.error?.message ||
          (this.isAr ? 'فشل تعديل الخدمة' : 'service not changed');

        Swal.fire({
          icon: 'error',
          title: this.isAr ? 'فشل تعديل الخدمة' : 'service not changed',
          text: this.isAr
            ? this.translateBackendError(backendMessage)
            : backendMessage,
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });
      },
    });
  }
  translateBackendError(message: string): string {
    if (!message) return 'حدث خطأ غير متوقع';

    if (message.includes('The image field must not be greater than 2048 kilobytes')) {
      return 'حجم الصورة أكبر من 2 ميجابايت، من فضلك ارفع صورة أصغر';
    }

    if (message.includes('The image field is required')) {
      return 'من فضلك اختر صورة';
    }

    return message;
  }
}
